export default {
    state:{
    sharedData: {},
    },
    mutations: {
        updateSharedData(state, { index, newValue }) {
            state.sharedData[index] = newValue
        },
        deleteSharedData(state, index) {
            delete state.sharedData[index]
        },
    },
    getters: {
        taskFormRevisionId: state => state.sharedData.taskFormData?.id??'',
        taskId: state => state.sharedData.taskId??'',
        formBodyId: state => state.sharedData.taskFormData?.form_body_id ?? '',
        formRevisionId: state => state.sharedData.taskFormData?.id ?? '',
        formId: state => state.sharedData.taskFormData?.form_id ?? '',

    },
    actions: {
        getId: state => state.sharedData.taskFormRevisionId,
    }

}
